module.exports = __webpack_public_path__ + "img/supporting_doc_true.354f1227.svg";